export enum FinanceAccessRulesKeyEnum {
  // --- Модуль FINANCE (Финансы) ---

  // --- Раздел FINANCE.SECTIONS.PLAN_FACT (Бюджетирование) ---
  // Вкладки
  FINANCE_PLAN_FACT_BALANCE_REPORT_READ = 'FINANCE_PLAN_FACT_BALANCE_REPORT_READ',
  FINANCE_PLAN_FACT_BALANCE_REPORT_WRITE = 'FINANCE_PLAN_FACT_BALANCE_REPORT_WRITE',

  FINANCE_PLAN_FACT_SETTINGS_READ = 'FINANCE_PLAN_FACT_SETTINGS_READ',
  FINANCE_PLAN_FACT_SETTINGS_WRITE = 'FINANCE_PLAN_FACT_SETTINGS_WRITE',

  FINANCE_PLAN_FACT_PAYMENT_OUTGOING_READ = 'FINANCE_PLAN_FACT_PAYMENT_OUTGOING_READ',

  FINANCE_PLAN_FACT_BUDGET_REQUEST_READ = 'FINANCE_PLAN_FACT_BUDGET_REQUEST_READ',
  FINANCE_PLAN_FACT_BUDGET_REQUEST_WRITE = 'FINANCE_PLAN_FACT_BUDGET_REQUEST_WRITE',

  FINANCE_PLAN_FACT_BALANCE_SHEET_READ = 'FINANCE_PLAN_FACT_BALANCE_SHEET_READ',

  FINANCE_PLAN_FACT_PLANNING_SCENARIO_READ = 'FINANCE_PLAN_FACT_PLANNING_SCENARIO_READ',
  FINANCE_PLAN_FACT_PLANNING_SCENARIO_WRITE = 'FINANCE_PLAN_FACT_PLANNING_SCENARIO_WRITE',

  // Разрешения Plan Fact
  FINANCE_PLAN_FACT_ACCESS_TO_ALL_BUDGET_REQUESTS = 'FINANCE_PLAN_FACT_ACCESS_TO_ALL_BUDGET_REQUESTS',
  FINANCE_PLAN_FACT_EDIT_ALL_BUDGET_REQUESTS = 'FINANCE_PLAN_FACT_EDIT_ALL_BUDGET_REQUESTS',
  FINANCE_PLAN_FACT_DELETE_ALL_BUDGET_REQUESTS_COMMENTS = 'FINANCE_PLAN_FACT_DELETE_ALL_BUDGET_REQUESTS_COMMENTS',
  FINANCE_PLAN_FACT_CAN_APPROVE_BUDGET_REQUEST_INSTEAD_OF_ANOTHER = 'FINANCE_PLAN_FACT_CAN_APPROVE_BUDGET_REQUEST_INSTEAD_OF_ANOTHER',
  FINANCE_PLAN_FACT_EDIT_PREVIOUS_PLAN = 'FINANCE_PLAN_FACT_EDIT_PREVIOUS_PLAN',
  FINANCE_PLAN_FACT_EDIT_DOCUMENT_RESTRICT_DATE = 'FINANCE_PLAN_FACT_EDIT_DOCUMENT_RESTRICT_DATE',

  // --- Раздел FINANCE.SECTIONS.DOCUMENT (Документы) ---
  // Вкладки
  FINANCE_DOCUMENT_REGISTRY_READ = 'FINANCE_DOCUMENT_REGISTRY_READ',
  FINANCE_DOCUMENT_REGISTRY_WRITE = 'FINANCE_DOCUMENT_REGISTRY_WRITE',

  FINANCE_DOCUMENT_TEMPLATE_READ = 'FINANCE_DOCUMENT_TEMPLATE_READ',
  FINANCE_DOCUMENT_TEMPLATE_WRITE = 'FINANCE_DOCUMENT_TEMPLATE_WRITE',

  FINANCE_DOCUMENT_VERIFY_READ = 'FINANCE_DOCUMENT_VERIFY_READ',
  FINANCE_DOCUMENT_VERIFY_WRITE = 'FINANCE_DOCUMENT_VERIFY_WRITE',

  FINANCE_DOCUMENT_BANK_STATEMENT_RULE_READ = 'FINANCE_DOCUMENT_BANK_STATEMENT_RULE_READ',
  FINANCE_DOCUMENT_BANK_STATEMENT_RULE_WRITE = 'FINANCE_DOCUMENT_BANK_STATEMENT_RULE_WRITE',

  FINANCE_DOCUMENT_ABC_ANALYSIS_READ = 'FINANCE_DOCUMENT_ABC_ANALYSIS_READ',

  FINANCE_DOCUMENT_SALARY_ACCRUAL_READ = 'FINANCE_DOCUMENT_SALARY_ACCRUAL_READ',
  FINANCE_DOCUMENT_SALARY_ACCRUAL_WRITE = 'FINANCE_DOCUMENT_SALARY_ACCRUAL_WRITE',

  FINANCE_DOCUMENT_SALARY_DISTRIBUTION_READ = 'FINANCE_DOCUMENT_SALARY_DISTRIBUTION_READ',
  FINANCE_DOCUMENT_SALARY_DISTRIBUTION_WRITE = 'FINANCE_DOCUMENT_SALARY_DISTRIBUTION_WRITE',

  FINANCE_DOCUMENT_ANALYTICS_RESET_READ = 'FINANCE_DOCUMENT_ANALYTICS_RESET_READ',

  // Разрешения Document
  FINANCE_DOCUMENT_EDIT_OTHER_USER_DOCUMENTS = 'FINANCE_DOCUMENT_EDIT_OTHER_USER_DOCUMENTS',
  FINANCE_DOCUMENT_CAN_LOCK_DOCUMENTS = 'FINANCE_DOCUMENT_CAN_LOCK_DOCUMENTS',
  FINANCE_DOCUMENT_READ_OTHER_USER_BILLS = 'FINANCE_DOCUMENT_READ_OTHER_USER_BILLS',
  FINANCE_DOCUMENT_EDIT_OTHER_USER_BILLS = 'FINANCE_DOCUMENT_EDIT_OTHER_USER_BILLS',

  // --- Раздел FINANCE.SECTIONS.BUSINESS (Сделки) ---
  // Вкладки
  FINANCE_BUSINESS_DEAL_READ = 'FINANCE_BUSINESS_DEAL_READ',
  FINANCE_BUSINESS_DEAL_WRITE = 'FINANCE_BUSINESS_DEAL_WRITE',

  FINANCE_BUSINESS_DEALS_GROUP_READ = 'FINANCE_BUSINESS_DEALS_GROUP_READ',
  FINANCE_BUSINESS_DEALS_GROUP_WRITE = 'FINANCE_BUSINESS_DEALS_GROUP_WRITE',

  FINANCE_BUSINESS_INTEGRATION_MEGAPLAN_READ = 'FINANCE_BUSINESS_INTEGRATION_MEGAPLAN_READ',
  FINANCE_BUSINESS_INTEGRATION_MEGAPLAN_WRITE = 'FINANCE_BUSINESS_INTEGRATION_MEGAPLAN_WRITE',

  FINANCE_BUSINESS_INTEGRATION_AMO_READ = 'FINANCE_BUSINESS_INTEGRATION_AMO_READ',
  FINANCE_BUSINESS_INTEGRATION_AMO_WRITE = 'FINANCE_BUSINESS_INTEGRATION_AMO_WRITE',

  FINANCE_BUSINESS_DEAL_TYPE_READ = 'FINANCE_BUSINESS_DEAL_TYPE_READ',
  FINANCE_BUSINESS_DEAL_TYPE_WRITE = 'FINANCE_BUSINESS_DEAL_TYPE_WRITE',

  FINANCE_BUSINESS_DEAL_STATUS_READ = 'FINANCE_BUSINESS_DEAL_STATUS_READ',
  FINANCE_BUSINESS_DEAL_STATUS_WRITE = 'FINANCE_BUSINESS_DEAL_STATUS_WRITE',

  FINANCE_BUSINESS_RENTAL_RATES_READ = 'FINANCE_BUSINESS_RENTAL_RATES_READ',
  FINANCE_BUSINESS_RENTAL_RATES_WRITE = 'FINANCE_BUSINESS_RENTAL_RATES_WRITE',

  // Разрешения Business
  FINANCE_BUSINESS_READ_ALL_DEALS = 'FINANCE_BUSINESS_READ_ALL_DEALS',
  FINANCE_BUSINESS_DELETE_OTHER_USER_DEAL_COMMENTS = 'FINANCE_BUSINESS_DELETE_OTHER_USER_DEAL_COMMENTS'
}
